<template>
  <div class="places-btn"
       @click="$emit('open')">
    <icon-places color="#7F66B6"
                 height="16"
                 width="12"/>

    <div>
      {{ $t("ourLocations") }}
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
  .places-btn {
    width: 170px;
    height: 50px;

    display: flex;
    justify-content: space-around;
    align-items: center;

    padding: 16px;
    font-size: 16px;
    color: #3E3A3B;
    cursor: pointer;

    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }
</style>